export const ItemTypes = {
  BOX: 'box',
}
export const ItemTypeOne = {
  CARD: 'card',
}